<template>
  <div class="old-versions-page">
    <HeadNav selected-language="en" page="old-versions" />

    <main class="old-main">
      <nav class="breadcrumb" aria-label="Breadcrumb">
        <a href="/">Home</a>
        <span aria-hidden="true">/</span>
        <span aria-current="page">Old Versions</span>
      </nav>

      <article class="content-card">
        <header class="page-header">
          <h1>GB WhatsApp Old Versions</h1>
          <p class="lead">
            Looking for an earlier GB WhatsApp release? Compare previous versions, review available release information and check compatibility considerations before choosing an older APK.
          </p>
        </header>

        <section class="content-section">
          <h2>Latest Available Version</h2>
          <h3>GB WhatsApp v18.80</h3>
          <p>
            GB WhatsApp v18.80 is the latest version listed on this website. Check the available download information and your device's compatibility before installing or updating the app.
          </p>
          <ul class="meta-list">
            <li><strong>Version:</strong> 18.80</li>
            <li><strong>Android compatibility:</strong> 5+</li>
            <li><strong>Download:</strong> Available</li>
          </ul>
          <a class="primary-link" :href="site.downloadPath">
            <i class="fa fa-cloud-download-alt" aria-hidden="true"></i>
            Download GB WhatsApp v18.80
          </a>
        </section>

        <section class="content-section">
          <h2>GB WhatsApp Old Version History</h2>
          <p>
            Version information may vary across third-party websites. The following table organizes historical release information to help users compare version numbers, file sizes, publication dates and Android requirements.
          </p>
          <div class="table-wrap">
            <table class="history-table">
              <thead>
                <tr>
                  <th>GB WhatsApp Version</th>
                  <th>File Size</th>
                  <th>Published / Updated</th>
                  <th>Minimum Android</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in historyRows" :key="row.version">
                  <td>{{ row.version }}</td>
                  <td>{{ row.size }}</td>
                  <td>{{ row.published }}</td>
                  <td>{{ row.android }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p class="note">
            File sizes, dates and Android requirements should be checked against reliable release information before publication. A historical listing does not necessarily mean that its APK remains available.
          </p>
        </section>

        <section class="content-section">
          <h2>Previous GB WhatsApp Versions</h2>
          <div class="release-grid">
            <article v-for="item in previousReleases" :key="item.version" class="release-card">
              <h3>GB WhatsApp v{{ item.version }}</h3>
              <p>{{ item.description }}</p>
              <a :href="site.downloadPath" class="primary-link primary-link--block">
                <i class="fa fa-cloud-download-alt" aria-hidden="true"></i>
                Download GB WhatsApp v{{ item.version }}
              </a>
            </article>
          </div>
        </section>

        <section class="content-section">
          <h2>Top GB WhatsApp Old Versions</h2>
          <p>
            Older releases may be relevant to users researching version history or compatibility with older devices. Confirm details before publication.
          </p>
          <div class="release-grid">
            <article v-for="item in topOldVersions" :key="item.version" class="release-card">
              <h3>GB WhatsApp v{{ item.version }}</h3>
              <p>An earlier GB WhatsApp release listed for the {{ item.year }} period.</p>
              <ul class="meta-list">
                <li><strong>Version:</strong> {{ item.version }}</li>
                <li><strong>Published year:</strong> {{ item.year }}</li>
                <li><strong>Android compatibility:</strong> {{ item.android }}</li>
              </ul>
              <a :href="site.downloadPath" class="primary-link primary-link--block">
                <i class="fa fa-cloud-download-alt" aria-hidden="true"></i>
                Download GB WhatsApp v{{ item.version }}
              </a>
            </article>
          </div>
        </section>

        <section class="content-section">
          <h2>GB WhatsApp Old Version vs. Latest Version</h2>
          <p>
            Older and newer GB WhatsApp releases may differ in interface design, available features, Android requirements and compatibility with current services. The actual differences depend on the specific releases being compared.
          </p>
          <div class="table-wrap">
            <table class="compare-table">
              <thead>
                <tr>
                  <th>Feature</th>
                  <th>Older Version</th>
                  <th>Latest Version</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in compareRows" :key="row.feature">
                  <td>{{ row.feature }}</td>
                  <td>{{ row.older }}</td>
                  <td>{{ row.latest }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>
            An older release is not automatically faster or more compatible with an older phone. Likewise, a newer version does not guarantee uninterrupted service or complete security. Compare the requirements of the specific versions before making a decision.
          </p>
        </section>

        <section class="content-section">
          <h2>How to Install an Older GB WhatsApp Version on Android</h2>
          <p>
            Before installing an older version, check the APK source, confirm device compatibility and review your backup options. Changing versions may affect locally stored chats, media files and application data.
          </p>
          <div v-for="step in installSteps" :key="step.title" class="step-block">
            <h3>{{ step.title }}</h3>
            <p v-html="step.text"></p>
          </div>
        </section>

        <section class="content-section">
          <h2>Before Installing an Older Version</h2>
          <div class="warning-grid">
            <article v-for="item in warnings" :key="item.title" class="warning-card">
              <h3>{{ item.title }}</h3>
              <p>{{ item.text }}</p>
            </article>
          </div>
        </section>

        <section class="content-section">
          <h2>Frequently Asked Questions</h2>
          <details v-for="(faq, index) in faqs" :key="faq.question" class="faq-item" :open="index === 0">
            <summary>{{ faq.question }}</summary>
            <p>{{ faq.answer }}</p>
          </details>
        </section>

        <section class="content-section">
          <h2>Related Security Articles</h2>
          <div class="related-grid">
            <a v-for="link in relatedLinks" :key="link.path" class="related-card" :href="link.path">
              <h3>{{ link.title }}</h3>
              <p>{{ link.description }}</p>
            </a>
          </div>
        </section>

        <p class="disclaimer">
          <a href="/">GBWhatsDroid.com</a> is an independent informational website and is not affiliated with, endorsed by or officially connected to WhatsApp or Meta. Information about third-party modified applications is provided for general reference. Verify files and compatibility details before installing any APK.
        </p>
      </article>
    </main>
  </div>
</template>

<script>
import '@/css/base.scss';
import '@/css/index.scss';
import HeadNav from '@/components/HeadNav.vue';
import site from '@/config/site.json';
import {
  VERSION_HISTORY_ROWS,
  COMPARE_ROWS,
  PREVIOUS_RELEASES,
  TOP_OLD_VERSIONS,
  INSTALL_STEPS,
  BEFORE_INSTALL_WARNINGS,
  OLD_VERSION_FAQS,
  RELATED_SECURITY_LINKS,
} from '@/constants/oldVersionsData';

export default {
  name: 'OldVersions',
  components: { HeadNav },
  data() {
    return {
      site,
      historyRows: VERSION_HISTORY_ROWS,
      compareRows: COMPARE_ROWS,
      previousReleases: PREVIOUS_RELEASES,
      topOldVersions: TOP_OLD_VERSIONS,
      installSteps: INSTALL_STEPS,
      warnings: BEFORE_INSTALL_WARNINGS,
      faqs: OLD_VERSION_FAQS,
      relatedLinks: RELATED_SECURITY_LINKS,
    };
  },
};
</script>

<style lang="scss" scoped>
.old-versions-page {
  min-height: 100vh;
  background: #f5f8f7;
  color: #14213d;
}

.old-main {
  width: min(920px, calc(100% - 32px));
  margin: 0 auto;
  padding: 24px 0 64px;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 4px 0 18px;
  color: #64748b;
  font-size: 13px;

  a {
    color: #0b6d47;
    font-weight: 600;
    text-decoration: none;
  }
}

.content-card {
  border: 1px solid #dfe9e4;
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 10px 28px rgba(23, 70, 52, 0.06);
  padding: 36px 42px 42px;
}

.page-header h1 {
  margin: 0 0 14px;
  color: #102b21;
  font-size: clamp(30px, 5vw, 44px);
  line-height: 1.15;
}

.lead {
  margin: 0;
  color: #41554d;
  font-size: 17px;
  line-height: 1.75;
}

.content-section {
  margin-top: 36px;
  color: #41554d;
  font-size: 16px;
  line-height: 1.75;

  h2 {
    margin: 0 0 12px;
    color: #173b2e;
    font-size: 24px;
  }

  h3 {
    margin: 18px 0 8px;
    color: #173b2e;
    font-size: 19px;
  }

  p {
    margin: 0 0 14px;
  }

  .step-block p ::v-deep a {
    color: #2563eb !important;
    font-weight: inherit;
    text-decoration: underline;
    text-underline-offset: 2px;

    &:hover,
    &:focus {
      color: #1d4ed8 !important;
    }
  }
}

.meta-list {
  margin: 0 0 16px;
  padding: 0;
  list-style: none;

  li {
    margin-bottom: 6px;
  }
}

.primary-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 18px;
  border-radius: 6px;
  background: #28a873;
  color: #fff !important;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  text-decoration: none;
  transition: background 0.2s ease;

  .fa {
    font-size: 16px;
  }

  &:hover {
    background: #1f9664;
  }
}

.primary-link--block {
  width: 100%;
  margin-top: 4px;
  box-sizing: border-box;
}

.table-wrap {
  overflow-x: auto;
  margin: 12px 0 16px;
  border: 1px solid #e3ece8;
  border-radius: 8px;
}

table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  table-layout: fixed;

  th,
  td {
    padding: 10px 14px;
    border: 1px solid #e3ece8;
    vertical-align: middle;
    word-wrap: break-word;
  }

  th {
    background: #fff;
    color: #173b2e;
    font-size: 13px;
    font-weight: 700;
  }

  tbody td {
    color: #41554d;
    font-size: 14px;
  }
}

.history-table {
  th:nth-child(1),
  td:nth-child(1) {
    width: 22%;
  }

  th:nth-child(2),
  td:nth-child(2) {
    width: 14%;
  }

  th:nth-child(1),
  th:nth-child(3),
  th:nth-child(4) {
    text-align: center;
  }

  th:nth-child(2) {
    text-align: right;
  }

  td:nth-child(1),
  td:nth-child(3),
  td:nth-child(4) {
    text-align: left;
  }

  td:nth-child(2) {
    text-align: right;
  }
}

.compare-table {
  th,
  td {
    text-align: left;
  }

  th {
    text-align: center;
  }

  td:first-child {
    width: 24%;
    font-weight: 600;
    color: #173b2e;
  }
}

.note {
  font-size: 14px;
  color: #5d6c66;
}

.release-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.release-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px;
  border: 1px solid #e3ece8;
  border-radius: 8px;
  background: #fafcfb;
  text-align: center;

  h3 {
    margin-top: 0;
    width: 100%;
  }

  p,
  .meta-list {
    flex: 1;
    width: 100%;
  }

  .meta-list {
    align-self: stretch;
    margin-bottom: 12px;
    padding-left: 1.15em;
    list-style: disc;
    list-style-position: outside;
    text-align: left;

    li {
      margin-bottom: 6px;
      padding-left: 0.1em;
    }
  }
}

.warning-grid {
  display: grid;
  gap: 12px;
}

.warning-card {
  padding: 16px 18px;
  border: 1px solid #e8efe9;
  border-radius: 8px;
  background: #f8fcfa;

  h3 {
    margin: 0 0 8px;
  }

  p {
    margin: 0;
  }
}

.faq-item {
  margin-bottom: 10px;
  padding: 14px 16px;
  border: 1px solid #e3ece8;
  border-radius: 8px;
  background: #fafcfb;

  summary {
    cursor: pointer;
    color: #173b2e;
    font-weight: 700;
  }

  p {
    margin: 10px 0 0;
  }
}

.related-grid {
  display: grid;
  gap: 12px;
}

.related-card {
  display: block;
  padding: 16px 18px;
  border: 1px solid #e3ece8;
  border-radius: 8px;
  background: #fff;
  color: inherit;
  text-decoration: none;

  h3 {
    margin: 0 0 8px;
    color: #173b2e;
    font-size: 17px;
  }

  p {
    margin: 0;
    font-size: 14px;
  }

  &:hover {
    border-color: #b8dcc9;
  }
}

.disclaimer {
  margin: 32px 0 0;
  padding-top: 20px;
  border-top: 1px solid #e7efeb;
  color: #5d6c66;
  font-size: 14px;
  line-height: 1.65;

  a {
    color: #2563eb !important;
    font-weight: inherit;
    text-decoration: underline;
    text-underline-offset: 2px;

    &:hover,
    &:focus {
      color: #1d4ed8 !important;
    }
  }
}

@media (max-width: 640px) {
  .content-card {
    padding: 24px 18px 28px;
  }

  .release-grid {
    grid-template-columns: 1fr;
  }
}
</style>
